import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';
import {User, UserResponse} from '../app/models/user.model';
import { Application } from '../app/models/application.model';
import { Observable } from 'rxjs';

export interface CurrentUser {
  id: number;
  username: string;
  email: string;
  name: string;
  tenantId: number;
  createdDate: string;
  enabled: boolean;
  applications: Application[];
}

export interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}

export interface UserProfile {
  id: number;
  username: string;
  email: string;
  mobile: string;
  name: string;
  tenantId: number;
  createdDate: string;
  enabled: boolean;
}

@Injectable({ providedIn: 'root' })
export class UserService {

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {
  }

  getUsers(page = 0, size = 10, query = '', sort = '', active?: boolean| null) {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (query) {
      params = params.set('query', query);
    }
    if (sort) {
      sort.split('&sort=').forEach(s => {
        params = params.append('sort', s);
      });
    }
    if (active !== null && active !== undefined) {
      params = params.set('active', active ? 'true' : 'false');
    }
    return this.http.get<UserResponse>(
      `${environment.baseUrl}/admin/users`,
      {params}
    );
  }

  getUserById(userId: number|string) {
    return this.http.get<User>(
      `${this.baseUrl}/admin/users/${userId}`
    );
  }

  enableUser(userId: number) {
    return this.http.post(`${this.baseUrl}/admin/users/${userId}/active`, {});
  }

  disableUser(userId: number) {
    return this.http.delete(`${this.baseUrl}/admin/users/${userId}/active`);
  }

  deleteUser(userId: number) {
    return this.http.delete(`${this.baseUrl}/admin/users/${userId}`);
  }

  createUser(payload: any) {
    return this.http.post(
      `${this.baseUrl}/admin/users/register`,
      payload
    );
  }

  updateUser(id: string, data: any) {
    return this.http.put<User>(`${this.baseUrl}/admin/users/${id}/info`, data);
  }

  getCurrentUser(): Observable<CurrentUser> {
    return this.http.get<CurrentUser>(`${this.baseUrl}/protected/users/me`);
  }

  changePassword(userId: string | number, newPassword: string, oldPassword?: string): Observable<UserProfile> {
    const payload: ChangePasswordRequest = {
      oldPassword: oldPassword || '',
      newPassword: newPassword
    };
    
    return this.http.put<UserProfile>(
      `${this.baseUrl}/admin/users/${userId}/password`,
      payload
    );
  }
}